/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ApiKey } from "./ApiKey";
export const ApiKeysResponse = core.serialization.object({
    data: core.serialization.list(ApiKey),
});
